export default __webpack_public_path__ + "static/media/teachers.6f7ffcb7.jpg";